<template lang="pug">
.notification
  .icon
    icon-pending(v-if="status === STATUS_TYPE.PENDING")
    icon-check(v-if="status === STATUS_TYPE.SUCCESS" :auto="true")
    icon-error(v-if="status === STATUS_TYPE.ERROR")
    icon-finished(v-if="status === STATUS_TYPE.FINISHED")
    icon-cancel(v-if="status === STATUS_TYPE.CANCELLED")
  .msg {{msg}}
  .sub-msg {{subMsg}}
  
</template>
<script>
import IconError from '@/components/wedgits/IconError'
import IconPending from '@/components/wedgits/IconPending'
import IconCheck from '@/components/wedgits/IconCheck'
import IconFinished from '@/components/wedgits/IconFinished'
import IconCancel from '@/components/wedgits/IconCancel'
export default {
  name: 'Notification',
  components: { IconCancel, IconFinished, IconCheck, IconPending, IconError },
  props: {
    status: {},
    msg: {},
    subMsg: { default: '' },
  },
  data() {
    return {
      STATUS_TYPE: {
        PENDING: 100,
        SUCCESS: 200,
        CANCELLED: 300,
        ERROR: 400,
        FINISHED: 500,
      },
    }
  },
  computed: {},
  methods: {},
  mounted() {},
}
</script>

<style scoped lang="sass">
@import "src/styles/common.sass"
.notification
  text-align: center
  width: 100%
  .icon
    margin: 0 auto
    width: pxToRem(108)
    height: pxToRem(108)
  .msg
    margin-top: pxToRem(49)
    color: black
    text-align: center
    font-size: pxToRem(36)
    line-height: pxToRem(50)
  .sub-msg
    margin-top: pxToRem(16)
    color: $cl-gray
    line-height: pxToRem(37)
    font-size: pxToRem(26)
</style>
